import { Link } from '@inertiajs/react'
import { TeamSummary } from '../../types'

interface Props {
  team: TeamSummary
  activeTab?: string
  actionItemCount?: number
}

const getTabs = (teamId: number) => [
  { key: 'overview', label: 'Overview', href: `/teams/${teamId}` },
  { key: 'agendas', label: 'Agendas', href: `/teams/${teamId}/agendas` },
  { key: 'scoreboard', label: 'Scoreboard', href: `/teams/${teamId}/scoreboard` },
  { key: 'rocks', label: 'F.A.S.T. Rocks', href: `/teams/${teamId}/rocks` },
  { key: 'action_items', label: 'Action Items', href: `/teams/${teamId}/action_items` },
  { key: 'topics', label: 'Topics', href: `/teams/${teamId}/topics` },
  { key: 'svep', label: 'Strategic Vision & Execution Plan', href: `/teams/${teamId}/svep` },
  { key: 'announcements', label: 'Announcements', href: `/teams/${teamId}/announcements` },
  { key: 'meetings', label: 'Meeting History', href: `/teams/${teamId}/meetings` },
]

export default function TeamSubNav({ team, activeTab, actionItemCount }: Props) {
  const tabs = getTabs(team.id)

  return (
    <div className="bg-white border-b border-stone/20">
      <div className="max-w-screen-2xl mx-auto px-6">
        <div className="flex items-center gap-4 pt-4 pb-0">
          <h2 className="text-2xl font-semibold text-text-primary font-heading">{team.name}</h2>
          <div className="flex items-center gap-1.5 text-text-secondary">
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
            <span className="text-base">{team.member_count}</span>
          </div>
        </div>
        <div className="flex items-center gap-0 mt-3 -mb-px overflow-x-auto">
          {tabs.map(tab => (
            <Link
              key={tab.key}
              href={tab.href}
              className={`px-4 py-3 text-base font-medium whitespace-nowrap transition-colors border-b-2 flex items-center gap-1.5 ${
                activeTab === tab.key
                  ? 'border-pinnacle-red text-pinnacle-red'
                  : 'border-transparent text-text-secondary hover:text-text-primary hover:border-[#351E1D]/20'
              }`}
            >
              {tab.label}
              {tab.key === 'action_items' && actionItemCount != null && actionItemCount > 0 && (
                <span className="text-sm bg-[#F5F5F5] text-text-secondary px-1.5 py-0.5 rounded-full min-w-[20px] text-center font-semibold">
                  {actionItemCount}
                </span>
              )}
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}
